import { render } from "./AfterAssessmentResult.vue?vue&type=template&id=867553da&scoped=true"
import script from "./AfterAssessmentResult.vue?vue&type=script&lang=js"
export * from "./AfterAssessmentResult.vue?vue&type=script&lang=js"

import "./AfterAssessmentResult.vue?vue&type=style&index=0&id=867553da&scoped=true&lang=css"

import exportComponent from "/var/www/tis-live/frontend/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-867553da"]])

export default __exports__